import { ModuleTypeEnum } from '../module';
import { TodayWidgetDefinition } from './widget';

export const PROJECT_WIDGETS: TodayWidgetDefinition[] = [
  {
    id: 'project-timeline',
    label: 'Project Timeline',
    description: 'Visualize the project schedule and milestones',
    moduleType: ModuleTypeEnum.PROJECT,
    defaultColumn: 'startDate',
    allowedColumns: ['startDate', 'endDate', 'status'],
    columnType: 'main',
    defaultSize: 'medium',
    minSize: 'medium',
    isDefault: true,
    icon: 'Calendar',
  },
];
